import Api from './Api';

export const genRequest = async (data, token,showLoading = null,hideLoading = null) => {
  const apiInstance = Api(() => token);
  if (!apiInstance) return;
  showLoading()
  const response = await apiInstance.call('generate-request', 'POST', data, true);

  const downloadUrl = response?.data?.download_url;
  hideLoading()
  if (downloadUrl) {
    const a = document.createElement('a');
    a.href = downloadUrl;
    a.setAttribute('download', '');
    a.download = ''; // Optional: specify filename if needed
    a.target = '_blank'; // Opens in a new tab (optional)
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a); // Clean up
   
    return true;
  }

  return false;
};
